import { Pipe, PipeTransform } from '@angular/core';
import { LanguageModel } from '../../../services';

@Pipe({
  name: 'getLocalizedFieldControlName'
})
export class GetLocalizedFieldControlNamePipe implements PipeTransform {

  transform(property: string, language: LanguageModel): string {
    return `${property}_${language.data.code.iv}`;
  }

}
